import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        company: '=',
        countries: '='
    },
    template: `
        <div class="heading01 type01">
            <h1>{{ vm.company.name }}</h1>
        </div>
        <manage-permissions-companies-form-general-data form="vm.form" company="vm.company" countries="vm.countries"/>
        <manage-permissions-companies-form-upload-employee-data company="vm.company"/>
        <ul class="actions01">
            <li>
                <a ui-sref="authorized.manage.permissions.companies.list()" class="btn discrete">
                    <span>{{ 'general.Back to list' | translate }}</span>
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor (FormFactory) {
        this.form = FormFactory.create(this.company, model => model.$update({ id: model.id }));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/companies/edit/index.js